import { PAGARME_PUBLIC_KEY } from "@env";

export default {
    PAGARME_PUBLIC_KEY,
};